import React, { useEffect } from 'react'

type Props = {
  containerRef: React.RefObject<HTMLElement>
  hasMore: boolean
  onLoadMore: () => void
  threshold?: number // distance from edge to trigger load
  direction?: 'up' | 'down' // scroll direction to trigger load (default: 'down')
}

const useInfiniteScroll = ({
  containerRef,
  hasMore,
  onLoadMore,
  threshold = 100,
  direction = 'down',
}: Props) => {
  useEffect(() => {
    const el = containerRef.current
    if (!el) return

    const handleScroll = () => {
      if (!hasMore) return

      if (direction === 'down') {
        // Load more when scrolling down near bottom
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - threshold) {
          onLoadMore()
        }
      } else {
        // Load more when scrolling up near top
        if (el.scrollTop <= threshold) {
          onLoadMore()
        }
      }
    }

    el.addEventListener('scroll', handleScroll)
    return () => el.removeEventListener('scroll', handleScroll)
  }, [containerRef, hasMore, onLoadMore, threshold, direction])
}

export default useInfiniteScroll
